import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import ReactDataGrid from 'react-data-grid';
import Pagination from '../../../../../data/Grid/GridView/Pagination';
import { getCsvContent } from '../apiClients/csvDataClient';
import './index.css';
import { useDocumentDispatch, useDocumentState } from '../context/documentContext';
import { Grid, CircularProgress, Typography, makeStyles } from '@material-ui/core';
import { csvItemsPerPage } from '../context/constants';
import Icon from '../../../../Icon';
import Button from '../../../../Button';
import cx from 'classnames';
import CellFormatter from '../../../Preview/CsvPreview/CsvCellFormater';
import getPrettyError from '../../../../../utils/getPrettyError';
var useStyles = makeStyles({
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-25px',
    marginTop: '-25px'
  },
  icon: {
    fontSize: 14
  },
  addRowButton: {
    marginTop: 12,
    marginBottom: 12
  },
  removed: {
    opacity: 0.3,
    pointerEvents: 'none'
  },
  modified: {
    fontWeight: 'bold'
  },
  rowRoot: {
    '& $deleteIcon': {
      display: 'none'
    },
    '&:hover': {
      '& $deleteIcon': {
        display: 'table-cell'
      }
    }
  },
  deleteIcon: {}
}, {
  name: 'ECCsvTable'
});

var CsvTable = function CsvTable(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;
  var classes = useStyles({});

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      pageIndex = _useState2[0],
      setPageIndex = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      selectLastRow = _useState4[0],
      setSelectLastRow = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var documentState = useDocumentState();
  var documentDispatch = useDocumentDispatch();
  var myRef = useRef(null);
  useEffect(function () {
    setPageIndex(0);
  }, [workspace, path]); // select current page rows including modifications

  var fileData = documentState.csvData[path];
  var rows = fileData && fileData.pagesMap[pageIndex];

  if (rows !== undefined) {
    if (fileData.edits !== null) {
      rows = rows.map(function (row, rowIndex) {
        var rowIndexInCsv = pageIndex * csvItemsPerPage + rowIndex;
        return fileData.edits.modifiedRows[rowIndexInCsv] !== undefined ? fileData.edits.modifiedRows[rowIndexInCsv] : row;
      });
    }

    var isLastPage = fileData.totalCount <= (pageIndex + 1) * csvItemsPerPage;
    if (fileData.edits && isLastPage) rows = rows.concat(fileData.edits.addedRows);
    rows = rows.map(function (row) {
      return [''].concat(_toConsumableArray(row));
    });
  }

  var columns = fileData && fileData.header.map(function (header, index) {
    return {
      key: index + 1,
      // compensation for first column for delete button
      name: header,
      resizable: true,
      editable: true,
      formatter: CellFormatter
    };
  });

  if (columns !== undefined) {
    columns = [{
      key: 'action',
      width: 36,
      resizable: false,
      editable: false
    }].concat(_toConsumableArray(columns));
  }

  useEffect(function () {
    setError('');

    if (rows === undefined) {
      getCsvContent(workspace, path, pageIndex * csvItemsPerPage, csvItemsPerPage).then(function (csvData) {
        documentDispatch({
          type: 'csvData_page_fetched',
          payload: {
            path: path,
            pageIndex: pageIndex,
            csvData: csvData
          }
        });
      }).catch(function (error) {
        setError(getPrettyError(error));
      });
    }

    if (rows !== undefined && selectLastRow) {
      myRef.current.openCellEditor(rows.length - 1, 1);
      setSelectLastRow(false);
    }
  }, [pageIndex, rows, selectLastRow, path]);

  var getCellActions = function getCellActions(column, row) {
    var cellActions = [{
      icon: React.createElement(Icon, {
        type: "delete",
        className: cx(classes.icon, classes.deleteIcon),
        color: "action"
      }),
      callback: function callback() {
        documentDispatch({
          type: 'csvData_row_removed',
          payload: {
            path: path,
            pageIndex: pageIndex,
            rowIndex: rows.indexOf(row)
          }
        });
      }
    }];
    return column.key === 'action' ? cellActions : null;
  };

  var onGridRowsUpdated = function onGridRowsUpdated(_ref2) {
    var fromRow = _ref2.fromRow,
        updated = _ref2.updated;
    var columnIndex = Object.keys(updated)[0];

    if (updated[columnIndex] !== rows[fromRow][columnIndex]) {
      documentDispatch({
        type: 'csvData_cell_modified',
        payload: {
          path: path,
          pageIndex: pageIndex,
          rowIndex: fromRow,
          columnIndex: columnIndex - 1,
          // compensation for first column for delete button
          value: updated[columnIndex]
        }
      });
    }
  };

  var RowRenderer = function RowRenderer(_ref3) {
    var renderBaseRow = _ref3.renderBaseRow,
        props = _objectWithoutProperties(_ref3, ["renderBaseRow"]);

    var rowIndexInCsv = pageIndex * csvItemsPerPage + props.idx;
    var isRowRemoved = fileData.edits !== null && fileData.edits.removedRows.includes(rowIndexInCsv);
    var isRowModified = fileData.edits !== null && (rowIndexInCsv >= fileData.totalCount || fileData.edits.modifiedRows[rowIndexInCsv] !== undefined);
    return React.createElement("div", {
      className: cx(classes.rowRoot, isRowRemoved && classes.removed, isRowModified && classes.modified)
    }, renderBaseRow(props));
  };

  var handlePageChange = function handlePageChange(event, nextPageIndex) {
    setPageIndex(nextPageIndex);
  };

  var handleAddRow = function handleAddRow() {
    var lastPageIndex = Math.max(0, Math.ceil(fileData.totalCount / csvItemsPerPage) - 1);
    setPageIndex(lastPageIndex);
    setSelectLastRow(true);
    documentDispatch({
      type: 'csvData_row_added',
      payload: {
        path: path
      }
    });
  };

  if (error) return React.createElement(Typography, {
    variant: "body2",
    color: "error",
    align: "center"
  }, error);
  if (columns === undefined) return React.createElement(CircularProgress, {
    className: classes.loadingIndicator
  });
  var renderRows = rows || [];
  return React.createElement("div", {
    className: "edit-css-grid"
  }, React.createElement(ReactDataGrid, {
    ref: myRef,
    columns: columns,
    rowGetter: function rowGetter(i) {
      return renderRows[i];
    },
    rowsCount: renderRows.length,
    onGridRowsUpdated: onGridRowsUpdated,
    enableCellSelect: true,
    minHeight: 35 * 15 + 40,
    minColumnWidth: 120,
    headerRowHeight: 50,
    getCellActions: getCellActions,
    rowRenderer: RowRenderer
  }), React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, csvItemsPerPage < fileData.totalCount && React.createElement(Grid, {
    item: true
  }, React.createElement(Pagination, {
    itemsPerPage: csvItemsPerPage,
    hideItemsPerPage: true,
    count: fileData.totalCount,
    page: pageIndex,
    onChangePage: handlePageChange
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    size: "small",
    icon: "add",
    variant: "outlined",
    color: "default",
    className: cx(classes.icon, classes.addRowButton),
    onClick: handleAddRow
  }, "Add Row"))));
};

export default CsvTable;